import React from 'react';

const ContractSigningIcon = React.memo(({color,...props}) => <svg width="20" height="19" viewBox="0 0 20 19" fill="none" {...props}>
    <path d="M10 18H19M14.5 1.49998C14.8978 1.10216 15.4374 0.878662 16 0.878662C16.2786 0.878662 16.5544 0.933532 16.8118 1.04014C17.0692 1.14674 17.303 1.303 17.5 1.49998C17.697 1.69697 17.8532 1.93082 17.9598 2.18819C18.0665 2.44556 18.1213 2.72141 18.1213 2.99998C18.1213 3.27856 18.0665 3.55441 17.9598 3.81178C17.8532 4.06915 17.697 4.303 17.5 4.49998L5 17L1 18L2 14L14.5 1.49998Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
</svg>)

export default ContractSigningIcon;

ContractSigningIcon.defaultProps = {
    color:'#212121'
};